import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Command palette open/close state (NS-3).
 *
 * Kept separate from `searchStore` so opening the palette doesn't wipe
 * the TopBar's query / results / recent queries. The palette *reads*
 * from searchStore (same backend, same flat-results shape as the
 * TopBar dropdown); this store only owns the overlay's visibility.
 *
 * Composition-style per CLAUDE.md §Frontend Principles §1 (Pinia SSOT).
 */
export const useCommandPaletteStore = defineStore('commandPalette', () => {
  const open = ref(false);

  function openPalette() {
    open.value = true;
  }

  function closePalette() {
    open.value = false;
  }

  function toggle() {
    open.value = !open.value;
  }

  return { open, openPalette, closePalette, toggle };
});
